import Carousel from './Carousel';
import Swiper, { Scrollbar, Navigation, Keyboard } from 'swiper';
Swiper.use([Scrollbar, Navigation, Keyboard]);

export default class CarouselPages extends Carousel {
	constructor(elm) {
		super(elm);

		this.slides = this.swiperContainer.querySelectorAll('.swiper-slide');

		this.boundMouseOverListener = this.mouseOverListener.bind(this);
        this.swiperContainer.addEventListener('mouseover', this.boundMouseOverListener);

		this.breakpoint = window.matchMedia('(min-width:768px)');

		this.init();
	}

	init() {
		this.swiper = new Swiper(this.swiperContainer, {
			init: false,
			threshold: 2,
			navigation: {
				prevEl: this.prev,
				nextEl: this.next,
			},
			scrollbar: {
				el: this.scrollbar,
				draggable: true,
				hide: false,
			},
			keyboard: {
				enabled: true,
				onlyInViewport: false,
			},
			slidesPerView: 1.05,
			spaceBetween: (window.innerWidth/100)*6,
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: (window.innerWidth/100)*2.5,
				},
				992: {
					slidesPerView: 3,
					spaceBetween: (window.innerWidth/100)*3,
				},
			}
		});
		this.swiper.on('afterInit', (e) => {
			// Make the middle slide 'active'
			if (this.breakpoint.matches === true) {
				if(this.slides.length>2) {
					this.slides.forEach((slide) => {
						slide.classList.remove('swiper-slide-active');
						if(slide.classList.contains('swiper-slide-next')) {
							slide.classList.add('swiper-slide-active');
						}
					});
				}
			}
			this.checkFooter();
		});

		this.swiper.on('resize', (e) => {
			this.checkFooter();
		});

		this.swiper.init();
	}


    mouseOverListener(e) {
		if (this.breakpoint.matches === true) {
			if (e.target.closest('.swiper-slide')) {
				this.slides.forEach((slide) => {
					slide.classList.remove('swiper-slide-active');
				});
				e.target.closest('.swiper-slide').classList.add('swiper-slide-active');
			}
		}
    }

	checkFooter() {
		if(this.prev.disabled&&this.next.disabled) {
			this.swiperContainer.closest('.section').querySelector('.c-carousel-footer').classList.add('c-carousel-footer--hidden');
			this.swiper.disable();
			this.swiperContainer.classList.add('swiper-disabled');
		} else {
			this.swiperContainer.closest('.section').querySelector('.c-carousel-footer').classList.remove('c-carousel-footer--hidden');
			this.swiper.enable();
			this.swiperContainer.classList.remove('swiper-disabled');

		}
		this.swiper.update();
		window.dispatchEvent(new CustomEvent('refresh-scroll'));
	}

	destroy() {
		this.swiperContainer.removeEventListener('mouseover', this.boundMouseOverListener);
	}
}
